// Test hooks for the child components that need to be specifically addressed with a test id
export const TestHooks = {
	LawyerAutoComplete: 'lawyer-auto-complete',
	LawyerItemDiv: 'lawyer-item-div',
	CreateLawyerButton: 'create-lawyer-button',
	MemberCard: 'member-card',
} as const;
